export const DocumentTabs = {
  CurrentDocuments: 'Current Application(s) Documents',
  PreviousDocuments: 'Old Application(s) Documents',
  OtherDocuments: 'Free To Me Documents',
  LearningPathway: 'Learning Pathway'
};

